//@flow
import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import getter from 'dibs-object-getter';

import styles from './RailContainer.scss';

import PhotoDetails from './PhotoDetails';
import FirmDetails from './FirmDetails';
import MoreProjects from './MoreProjectsContainer';
import RailTagContainer from './RailTagContainer';

import type { RelayProp } from 'react-relay';
import type { RailContainer_tradePhoto as TradePhoto } from './__generated__/RailContainer_tradePhoto.graphql';
import type { RailContainer_photoQuery as TradePhotoQueryOutput } from './__generated__/RailContainer_photoQuery.graphql';

type RailContainerProps = {
    relay?: RelayProp,
    isClient: boolean,
    tradePhoto: ?TradePhoto,
    photoQuery: ?TradePhotoQueryOutput,
};

export const RailContainer = (props: RailContainerProps) => {
    const firmId = getter(props)
        .at('photoQuery')
        .value('firmId');
    const projectId = getter(props)
        .at('photoQuery')
        .value('projectId');
    return (
        <div className={styles.container}>
            <PhotoDetails
                tradePhoto={(props.tradePhoto: ?Object)}
                photoQuery={(props.photoQuery: ?Object)}
            />
            <FirmDetails photoQuery={(props.photoQuery: ?Object)} />
            <RailTagContainer tradePhoto={(props.tradePhoto: ?Object)} />
            {props.isClient && (
                <MoreProjects firmId={firmId} projectId={projectId} relay={props.relay} />
            )}
        </div>
    );
};

export default createFragmentContainer(RailContainer, {
    photoQuery: graphql`
        fragment RailContainer_photoQuery on TradePhotosQueryOutput {
            ...FirmDetails_photoQuery
            ...PhotoDetails_photoQuery
            firmId
            projectId
        }
    `,
    tradePhoto: graphql`
        fragment RailContainer_tradePhoto on TradePhoto {
            ...PhotoDetails_tradePhoto
            ...RailTagContainer_tradePhoto
        }
    `,
});
